
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    isWrongQuestion: {
      type: Boolean,
      default: false,
    },
  },
})
export default class CommondNoData extends Vue {}
